module.exports = "/images/MobileFooter.png?103dadf713986bf479589d10e8faada7";